import React from 'react';
import {Component} from 'react';
import '../style/showcase.scss';
import '../components/header';
import Header from '../components/header';
import Footer from '../components/footer';
import background from '../images/stretch.jpg'
import stairs from '../images/stretch.jpg'
import a from '../images/1.jpg'
import b from '../images/4.jpg'
import c from '../images/3.jpg'
import d from '../images/5.jpg'
import Showcase from '../components/showcase';
import Accordion from '../components/accordion';

class Crossfit extends Component {
  render() {

    let data = [
    	{
        title: "Do I have to have a Group Class Membership?", 
        content: `No! We find that CrossFit is for everyone, but that the group setting of a traditional class might not be. So make sure you schedule our No Sweat Intro with a coach today to find out what your goals are and if 1-on-1 is for you!`
      }, {
        title: "How easy is it to schedule a 1-on-1?", 
        content: `Super easy! Purchase the length of session you want above and a coach will reach out to schedule a time that works for you. After your first session you can also schedule at your convenience via the Wodify App. or in person with your 1-on-1 coach.`
      },{
        title: "Do I buy my 1-on-1 sessions one at a time or in a package?", 
        content: `You can do either! We believe in a individualized approach to our coaching and billing. Whatever mixture of 30 or 60 minutes and or amounts of each is always up to you.`
      }
    ];
    return(
  <>
    <Header color='#707070'/>
    <Showcase background={background} name='1-ON-1 COACHING' />

    <section id="about" className="container py-5 my-5">
        <div className="row">
            <div className="col">
                <img src={stairs} className="img-responsive left-column-img"/>
                <h2 className="teko my-4">1-ON-1 COACHING</h2> 
                <p className="secondary">1-ON-1 Coaching is a highly if not the most effective and efficient way to achieve your individual fitness goals. Your coach will work with you to identify and clarify your fitness goals, gage your ability to move, and create a program targeted at improving your deficiencies and optimizing your strengths, thus allowing you to achieve your goals in the shortest time possible. 1-ON-1 Coaching is best if you have been sedentary for a long period of time, are training for a specific sport or event, have significant health limitations, or just prefer the additional attention and/or accountability. Our 1 on 1 coaching prices go from $50 for 30-Minutes and $85 for 60-Minutes. 30-Minute “Accelerator“ sessions are a great way for veteran athletes to accelerate the more complicated skills we teach here. Please arrive 10-15 minutes early to get warm and sweaty to get the most out of your session!</p>
                <br/>
                <h2 className="teko my-4">PRICING</h2>
                <br/>
                <div className="priceRow row flex-items-xs-middle flex-items-xs-center">

            <div className="col-xs-12 col-lg-4">
            <div className="card text-xs-center">
                <div className="card-header">
                <h3 className="display-2 text-center"><span className="currency">$</span>50<span className="period">/session</span></h3>
                </div>
                <div className="card-block">
                <h4 className="card-title"> 
                    1:1 30 Minute Training
                </h4>
                <ul className="list-group">
                    <li className="list-group-item">1 - 1:1 30min Session</li>
                    <li className="list-group-item"><br/></li>
                    <li className="list-group-item"><br/></li>
                    <li className="list-group-item"><br/></li>
                    <li className="list-group-item"><br/></li>
                    <li className="list-group-item"><a href="https://crossfitdeliverance.wodify.com/OnlineSalesPortal/PurchaseByKeyEntry.aspx?Key=sSC2eSvGMKiucRHxKGlduMiik" className="primary-button">Purchase Now</a></li>
                </ul>
                </div>
            </div>
            </div>


            <div className="col-xs-12 col-lg-4">
            <div className="card text-xs-center">
                <div className="card-header">
                <h3 className="display-2 text-center"><span className="currency">$</span>85<span className="period">/session</span></h3>
                </div>
                <div className="card-block">
                <h4 className="card-title"> 
                    1:1 60 Minute Training
                </h4>
                <ul className="list-group">
                    <li className="list-group-item">1 - 1:1 30min Session</li>
                    <li className="list-group-item"><br/></li>
                    <li className="list-group-item"><br/></li>
                    <li className="list-group-item"><br/></li>
                    <li className="list-group-item"><br/></li>
                    <li className="list-group-item"><a href="https://crossfitdeliverance.wodify.com/OnlineSalesPortal/PurchaseByKeyEntry.aspx?Key=7Y55lIdR7kDBgbf0QeTr2qXzX
" className="primary-button">Purchase Now</a></li>
                </ul>
                </div>
            </div>
            </div>


            <div className="col-xs-12 col-lg-4">
            <div className="card text-xs-center">
                <div className="card-header">
                <h3 className="display-2"><span className="currency">$</span>249<span className="period">/month</span></h3>
                </div>
                <div className="card-block">
                <h4 className="card-title"> 
                    Foundations
                </h4>
                <ul className="list-group">
                    <li className="list-group-item">5 - 1:1 30min Session</li>
                    <li className="list-group-item">First Month Crossfit</li>
                    <li className="list-group-item"><br/></li>
                    <li className="list-group-item"><br/></li>
                    <li className="list-group-item"><br/></li>
                    <li className="list-group-item"><a href="https://crossfitdeliverance.wodify.com/OnlineSalesPortal/PurchaseByKeyEntry.aspx?Key=Icve01lu5CJiLWYz4fSTVWVfV" className="primary-button">Purchase Now</a></li>
                </ul>
                </div>
            </div>
            </div>
            </div>
                <h2 className="teko my-5">COMMON QUESTIONS</h2>
                <Accordion data={data} />
            </div>
             
            </div> 
    </section>
    <Footer />
  </>
);
}
}

export default Crossfit
